<template>
  <iRow width="hug">
    <iTextEditInput
      v-model="localFirstName"
      label="First Name"
      :min-width="400"
      :disabled="editMode"
      editable-on-click
      @submit="submit"
    />
  </iRow>
</template>

<script>
// `~/stores/user-store` lives outside the editor directory tree.
// Canvas preview keeps the value local; FanWeb runs the real
// submitNewFirstName flow.
import { UserSettingsPageElementMixin } from "%/dynamic-component-editor/standard-pages/user-settings-page/user-settings-page-element-mixin";

export default {
  name: "ChangeFirstName",
  mixins: [UserSettingsPageElementMixin],
  elementPanelSettings: {
    displayName: "Change First Name Field",
    displayIcon: "document",
    elementGroup: "userSettingsElements",
    elementType: "element",
  },
  data() {
    return {
      localFirstName: "First",
    };
  },
  methods: {
    submit() {
      // No-op in Studio canvas preview.
    },
  },
};
</script>
